import React from 'react';
import { Layout, CartContent } from 'components';

const Cart = () => {
  return (
    <Layout>
      <CartContent />
    </Layout>
  );
};

export default Cart;
